import {
  FormControlLabel, Radio
} from '@material-ui/core';
import LocalizedText from 'commons/LocalizedText/LocalizedText';
import * as PropTypes from 'prop-types';
import * as React from 'react';

export const CustomRadio = ({
  checked,
  disabled,
  label,
  onClick

}) => {
  return (
    <FormControlLabel
      checked={checked}
      control={<Radio
        disabled={disabled}
      />}
      disabled={disabled}
      label={<LocalizedText>{label}</LocalizedText>}
      onClick={onClick}
    />
  );
};


CustomRadio.propTypes = {
  checked: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func
};

CustomRadio.defaultProps = {
  checked: false,
  label: '',
  onClick: () => {}
};